/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type DeleteStaffInput = {
  guid: string | number;
};

export type StaffRole =
  | 'BRANCH_MANAGER'
  | 'CORPORATION_ADMIN'
  | 'ENTRANCE_MANAGER'
  | 'MEMBER';

export type SettingsPageMemberManagementDetailViewQueryVariables = Exact<{
  staffGUID: string | number;
}>;


export type SettingsPageMemberManagementDetailViewQuery = { viewer: { staff: { guid: string } }, planner: { id: string, email: string } | null, staff: { guid: string, email: string, name: string | null, role: Types.StaffRole } };

export type DeleteStaffMutationVariables = Exact<{
  input: Types.DeleteStaffInput;
}>;


export type DeleteStaffMutation = { deleteStaff: { __typename: 'DeleteStaffSuccessPayload' } };


export const SettingsPageMemberManagementDetailViewDocument = gql`
    query SettingsPageMemberManagementDetailView($staffGUID: ID!) {
  viewer {
    staff {
      guid
    }
  }
  planner {
    id
    email
  }
  staff(guid: $staffGUID) {
    guid
    email
    name
    role
  }
}
    `;

/**
 * __useSettingsPageMemberManagementDetailViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageMemberManagementDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageMemberManagementDetailViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageMemberManagementDetailViewQuery({
 *   staffGUID: // value for 'staffGUID'
 * });
 */
export function useSettingsPageMemberManagementDetailViewQuery(variables: SettingsPageMemberManagementDetailViewQueryVariables | VueCompositionApi.Ref<SettingsPageMemberManagementDetailViewQueryVariables> | ReactiveFunction<SettingsPageMemberManagementDetailViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementDetailViewQuery, SettingsPageMemberManagementDetailViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementDetailViewQuery, SettingsPageMemberManagementDetailViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementDetailViewQuery, SettingsPageMemberManagementDetailViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageMemberManagementDetailViewQuery, SettingsPageMemberManagementDetailViewQueryVariables>(SettingsPageMemberManagementDetailViewDocument, variables, options);
}
export function useSettingsPageMemberManagementDetailViewLazyQuery(variables?: SettingsPageMemberManagementDetailViewQueryVariables | VueCompositionApi.Ref<SettingsPageMemberManagementDetailViewQueryVariables> | ReactiveFunction<SettingsPageMemberManagementDetailViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementDetailViewQuery, SettingsPageMemberManagementDetailViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementDetailViewQuery, SettingsPageMemberManagementDetailViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageMemberManagementDetailViewQuery, SettingsPageMemberManagementDetailViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageMemberManagementDetailViewQuery, SettingsPageMemberManagementDetailViewQueryVariables>(SettingsPageMemberManagementDetailViewDocument, variables, options);
}
export type SettingsPageMemberManagementDetailViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageMemberManagementDetailViewQuery, SettingsPageMemberManagementDetailViewQueryVariables>;
export const DeleteStaffDocument = gql`
    mutation deleteStaff($input: DeleteStaffInput!) {
  deleteStaff(input: $input) {
    __typename
  }
}
    `;

/**
 * __useDeleteStaffMutation__
 *
 * To run a mutation, you first call `useDeleteStaffMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStaffMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteStaffMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStaffMutation(options: VueApolloComposable.UseMutationOptions<DeleteStaffMutation, DeleteStaffMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteStaffMutation, DeleteStaffMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteStaffMutation, DeleteStaffMutationVariables>(DeleteStaffDocument, options);
}
export type DeleteStaffMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteStaffMutation, DeleteStaffMutationVariables>;